export const processNewLineText = (text: string) => {
  if (!text || typeof text !== 'string') return ''
  return text.replace(/\\n/g, '\n')
}

export const getAnswer = (answer: any) => {
  if (!answer) return ''
  if (typeof answer === 'string') return answer
  if (typeof answer === 'object') return answer.other
  return ''
}

export const hasWords = (text: string) => {
  const hasWords = /\S/.test(text)
  return hasWords
}

type WordSegmenter = {
  segment: (text: string) => Iterable<{ isWordLike?: boolean }>
}

// Intl.Segmenter postdates the ES2020 lib this project compiles against
const WordSegmenterConstructor = (
  Intl as unknown as {
    Segmenter?: new (
      locale?: string,
      options?: { granularity: 'word' }
    ) => WordSegmenter
  }
).Segmenter

// Chinese and Japanese put no spaces between words
const CJK_CHARACTER = /[぀-ヿ㐀-䶿一-鿿豈-﫿]/g

export const countWords = (text: string) => {
  if (!text || typeof text !== 'string' || !text.trim()) return 0

  if (WordSegmenterConstructor) {
    const segmenter = new WordSegmenterConstructor(undefined, {
      granularity: 'word',
    })
    let count = 0
    for (const segment of segmenter.segment(text)) {
      if (segment.isWordLike) count++
    }
    return count
  }

  // Older browsers: a CJK character counts as a word, the rest splits on spaces
  const cjk = text.match(CJK_CHARACTER)?.length ?? 0
  const rest = text.replace(CJK_CHARACTER, ' ').trim()
  return cjk + (rest ? rest.split(/\s+/).length : 0)
}